<template>
    <v-container :class="isMobileSize() ? 'ma-0 pa-0' : null">
        <v-row>
            <v-col>
                <ConfigList />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ConfigList from '../components/ConfigList.vue'

    export default {
        components: { 
            ConfigList
        },
        
    }
</script>